import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    color: "#000",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  logo: {
    marginLeft: "15px",
    marginBottom: "15px",
    width: "100%",
  },
}));
